import React, { useEffect, useState } from 'react';
import { Container, Card, Button, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Recurso, StatusRecurso } from '../../model/Candidato/Recurso'; 
import useRecursoStore from '../../stores/useRecursoStore';
import { toast } from 'react-toastify';

const SelecionarBancaRecursosPendentes: React.FC = () => {
    const { getRecursosPendentes } = useRecursoStore();
    const [bancas, setBancas] = useState<{ bancaId: string, data: string, recursos: Recurso[] }[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const navigate = useNavigate();

    // Função para formatar a data
    const formatarData = (data: string | null): string | null => {
        if (!data) return null;
        const partes = data.split('T')[0].split('-');
        return `${partes[2]}/${partes[1]}/${partes[0]}`;
    };

    // Carrega os recursos pendentes e agrupa por bancaId e dataCriacao
    useEffect(() => {
        const fetchRecursos = async () => {
            try {
                setLoading(true);
                await getRecursosPendentes(); // Busca todos os recursos pendentes
                const recursos = useRecursoStore.getState().recursos; // Acessa os recursos da store

                // Agrupa os recursos por bancaId e dataCriacao
                const bancasMap = recursos.reduce((acc, recurso) => {
                    if (recurso.status === StatusRecurso.CRIADO) { // Filtra apenas recursos pendentes
                        const bancaId = recurso.bancaId; // Usa o campo bancaId do recurso
                        const dataCriacao = formatarData(recurso.dataCriacao); // Formata a data de criação

                        if (bancaId && dataCriacao) { // Verifica se bancaId e dataCriacao existem
                            const key = `${bancaId}-${dataCriacao}`; // Cria uma chave única combinando bancaId e dataCriacao

                            if (!acc[key]) {
                                acc[key] = {
                                    bancaId,
                                    data: dataCriacao,
                                    recursos: [],
                                };
                            }
                            acc[key].recursos.push(recurso);
                        }
                    }
                    return acc;
                }, {} as { [key: string]: { bancaId: string, data: string, recursos: Recurso[] } });

                // Converte o mapa em um array de objetos
                const bancasArray = Object.values(bancasMap);

                setBancas(bancasArray);
            } catch (error: any) {
                console.error('Erro ao buscar recursos pendentes:', error);
                toast.error('Erro ao carregar recursos pendentes.');
            } finally {
                setLoading(false);
            }
        };
        fetchRecursos();
    }, [getRecursosPendentes]);

    // Redireciona para a página de recursos da banca selecionada
    const handleSelecionarBanca = (bancaId: string) => {
        navigate(`/bancas/${bancaId}/recursos`);
    };

    return (
        <Container className="mt-5">
            <h1 className="mb-4">Bancas com Recursos Pendentes</h1>
            {loading ? (
                <div>Carregando...</div>
            ) : (
                <Row>
                    {bancas.map((banca) => (
                        <Col key={`${banca.bancaId}-${banca.data}`} md={4} className="mb-4">
                            <Card>
                                <Card.Body>
                                    <Card.Title>Banca realizada em {banca.data}</Card.Title>
                                    <Card.Text>
                                        <strong>Recursos Pendentes:</strong> {banca.recursos.length}
                                        <br />
                                    </Card.Text>
                                    <Button
                                        variant="primary"
                                        onClick={() => handleSelecionarBanca(banca.bancaId)}
                                    >
                                        Ver Recursos
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            )}
        </Container>
    );
};

export default SelecionarBancaRecursosPendentes;